import { createWorker } from 'tesseract.js';

export async function extractRestaurantText(image, onProgress) {
  const worker = await createWorker('ara+eng', 1, {
    logger(message) {
      if (typeof message.progress === 'number') {
        onProgress?.(message.progress, message.status || 'Reading restaurant sign');
      }
    },
  });

  try {
    await worker.setParameters({
      preserve_interword_spaces: '1',
      tessedit_pageseg_mode: '11',
      user_defined_dpi: '220',
    });
    const result = await worker.recognize(image);
    return {
      text: result.data.text.trim(),
      confidence: Math.max(0, Math.min(1, Number(result.data.confidence || 0) / 100)),
    };
  } finally {
    await worker.terminate();
  }
}
